/* import { useState, useEffect, useContext, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import { Modal } from 'react-bootstrap'
import { FormattedMessage, useIntl } from 'react-intl'

import Swal from 'sweetalert2'

import { getSalary, postSalary, putSalary } from '../../API/Employee/Salary'
import { getProfile, contractTypesList } from '../../API/Employee/Profile'
import { getEmployee } from '../../API/Employee/Employee'
import { CompanyContext } from '../../Store/CompanyContext'

import { btnTranslate, salaryTitle, wheelCollaboratorTranslate } from '../../i18n/translatedMessages'
import { personalInfoTranslate } from '../../i18n/translatedMessages'

import { CulturaIcon, HabilidadesIcon, SalarioIcon } from '../../Icons/CollaboratorsIcons'

import { useGenerateReport, useSalaryCalculation } from '../../hooks'

import HeaderCarouselMandala from './Components/HeaderCarouselMandala/HeaderCarouselMandala'
import ModalResponseStatus from '../../Components/ModalResponseStatus/ModalResponseStatus'
import TablePositionItem from '../Services/Components/PayBalance/Components/TablePositionItemAnalytics'

const Salario = () => {
	const language = useIntl()
	const { id } = useParams()

	const { store, actions } = useContext(CompanyContext)

	const [showModalEdit, setShowModalEdit] = useState(false)
	const [employeeInfoData, setEmployeeInfoData] = useState([])

	const [user, setUser] = useState(JSON.parse(localStorage.getItem('user')))
	const [userid, setUserid] = useState()
	const [colabId, setColabId] = useState()
	const [colabEmail, setColabEmail] = useState(null)

	const [salaryInfo, setSalaryInfo] = useState({ contract: null })
	const [contractList, setContractList] = useState([])

	const objEmpty = {
		id: id,
		salary: '',
		fixedSalary: '',
		typeCurrency: '',
		lastAdjustDate: '',
		contract: '',
	}

	const profileEmpty = {
		employerId: id,
		mailPersonal: '',
		phone: '',
		document: '',
		birth: '',
		linkedIn: '',
		facebook: '',
		instagram: '',
		skype: '',
		twitter: '',
		gender: '',
		maritalStatus: '',
		childrens: '',
		city: '',
		country: '',
		address: '',
		nationality: '',
		transport: '',
		contract: '',
		boss: '',
		bank: '',
		currentAccount: '',
		healthPlan: '',
		height: 0,
		weight: 0,
		enfermedad: '',
		pcd: '',
		typePCD: '',
		hobies: '',
		sports: '',
		interests: '',
		voluntaryWork: '',
	}

	const [employeeProfile, setEmployeeProfile] = useState(profileEmpty)

	const { handleReport } = useGenerateReport()
	const calculation = useSalaryCalculation(userid, employeeInfoData)

	const smtmRequest = useCallback(async colabEmail => {
		if (colabEmail) {
			try {
				const data = await fetch(`https://smtm.co/v1/position_by_mydna_email?email=${colabEmail}`)
				const rest = await data.json()
				setEmployeeInfoData(rest)
			} catch (error) {
				Swal.fire({
					icon: 'error',
					title: 'Oops...',
					text: 'Algo salió mal !',
				})
			}
		} else {
			console.warn('Email no válido o undefined en smtmRequest')
		}
	}, [])

	useEffect(() => {
		setUserid(id)

		if (colabEmail !== undefined && colabEmail) {
			smtmRequest(colabEmail)
		}
	}, [id, colabEmail, smtmRequest])

	useEffect(() => {
		async function fetchData() {
			const response = await getEmployee(id)
			setColabId(response.userId)
			if (response?.employerUser && response?.employerUser?.email && response?.employerUser?.email !== undefined) {
				setColabEmail(response?.employerUser?.email)
			}
		}
		fetchData()
	}, [userid])

	const asyncRequests = async () => {
		const [profileAux] = await getProfile(id)
		const salary = await getSalary(id)

		const salaryMap = salary[salary.length - 1]
		salary?.length > -1
			? setSalaryInfo({
					...salaryMap,
					contract: profileAux?.contract,
			  })
			: setSalaryInfo([objEmpty])
		await getSalary(id)
		setContractList(await contractTypesList())
		setEmployeeProfile(profileAux)
	}

	useEffect(() => {
		setUser(JSON.parse(localStorage.getItem('user')))
		asyncRequests()
	}, [])

	const handleChange = e => {
		const { name, value } = e.target

		setSalaryInfo({
			...salaryInfo,
			[name]: value,
		})
	}

	const handleSend = async (e, salid) => {
		if (
			salaryInfo.salary === null ||
			salaryInfo.salary === '' ||
			salaryInfo.fixedSalary === null ||
			salaryInfo.fixedSalary === '' ||
			salaryInfo.typeCurrency === null ||
			salaryInfo.typeCurrency === '' ||
			salaryInfo.lastAdjustDate === null ||
			salaryInfo.lastAdjustDate === ''
		) {
			Swal.fire({
				title: 'Hola 👋',
				text: 'Por favor completa todos los campos',
				icon: 'info',
				confirmButtonText: '👌',
			})
		} else {
			const objSalarySend = {
				salary: salaryInfo.salary,
				fixedSalary: salaryInfo.fixedSalary,
				typeCurrency: salaryInfo.typeCurrency,
				employerId: id,
				lastAdjustDate: salaryInfo.lastAdjustDate,
			}
			const postorputSalary = salid ? await putSalary(objSalarySend, salid, colabEmail) : await postSalary(objSalarySend, colabEmail)
			smtmRequest(colabEmail)
			asyncRequests()
			setShowModalEdit(false)
			Swal.fire({
				icon: 'success',
			})
		}
	}

	const handleClose = () => actions.setShowModalResponseStatus(false)

	const formatedDate = date => {
		const newDate = new Date(date)
		return `${('0' + newDate.getDate()).slice(-2)}/${('0' + (newDate.getMonth() + 1)).slice(-2)}/${newDate.getFullYear()}`
	}

	return (
		<>
			<div>TEste</div>

			<div className='container-fluid'>
				<Modal show={showModalEdit} onHide={() => setShowModalEdit(false)}>
					<Modal.Header closeButton>
						<Modal.Title>Editar Salario</Modal.Title>
					</Modal.Header>
					<div className='row justify-content-center pt-5 pb-3'>
						<div className='col-12'>
							<div className='container-fluid'>
								<div className='row align-items-center justify-content-center mb-4'>
									<div className='col'>
										<label htmlFor='employeeSalary' className='color-blue form-label'>
											{personalInfoTranslate.personalFixBruteSalary}
										</label>
										<input
											className='form-control text-center m-0'
											name='salary'
											type='text'
											aria-label='salario'
											value={salaryInfo?.salary}
											onChange={e => handleChange(e)}
										/>
									</div>
									<div className='col'>
										<label htmlFor='employeeTypeCurrency' className='form-label'>
											{personalInfoTranslate.personalCoin}
										</label>
										<select
											className='form-select rounded-pill m-0'
											aria-label='Default select example'
											name='typeCurrency'
											value={salaryInfo?.typeCurrency}
											onChange={e => handleChange(e)}
										>
											<option>Seleccione...</option>
											<option value='AR$'>AR$</option>
											<option value='CLP'>CLP</option>
											<option value='COP'>COP</option>
											<option value='MEX'>MEX</option>
											<option value='R$'>R$</option>
											<option value='S/.'>S/.</option>
											<option value='USD'>USD</option>
										</select>
									</div>
								</div>
							</div>
						</div>
						<div className='col-12'>
							<div className='container-fluid'>
								<div className='row align-items-center justify-content-center mb-4'>
									<div className='col'>
										<label htmlFor='employeeFixedSalary' className='form-label'>
											{personalInfoTranslate.personalVariableSalary}
										</label>
										<select
											className='form-select rounded-pill m-0'
											aria-label='Default select example'
											name='fixedSalary'
											value={salaryInfo?.fixedSalary}
											onChange={e => handleChange(e)}
										>
											<option>Seleccione...</option>
											{Array.from({ length: 20 }).map((_, index) => {
												return (
													<option key={index} value={index / 2 + 0.5}>
														{index / 2 + 0.5}
													</option>
												)
											})}
										</select>
									</div>
									<div className='col'>
										<label htmlFor='lastAdjustDate' className='form-label'>
											Último ajuste salarial:
										</label>
										<input
											type='date'
											id='lastAdjustDate'
											name='lastAdjustDate'
											className='form-control rounded-pill'
											value={salaryInfo?.lastAdjustDate}
											onChange={e => handleChange(e)}
										/>
									</div>
								</div>
							</div>
						</div>
						<div className='col-12 px-4'>
							<button
								className='btn rounded-pill btn-salvar w-100'
								data-salid={salaryInfo?.id}
								onClick={e => handleSend(e, salaryInfo.id)}
							>
								{btnTranslate.saveButton}
							</button>
						</div>
					</div>
				</Modal>

				<FormattedMessage id='nextButton'>
					{msg => (
						<ModalResponseStatus
							show={store.showModalResponseStatus}
							handleClose={handleClose}
							message={store.messageResponseStatus}
							successMessage={store.responseStatus}
							btnRight={msg}
						/>
					)}
				</FormattedMessage>
				<div className='row mb-4'>
					<div>
						<HeaderCarouselMandala
							actualTitle={wheelCollaboratorTranslate.salary}
							prevTitle={wheelCollaboratorTranslate.culture}
							routePrev={`/app/analytic/cultura/${id}`}
							nextTitle={wheelCollaboratorTranslate.habilities}
							routeNext={`/app/analytic/habilidades/${id}`}
							iconActual={<SalarioIcon />}
							iconPrev={<CulturaIcon />}
							iconNext={<HabilidadesIcon />}
						/>
					</div>
					<div className='row'>
						<div className='col'>
							<TablePositionItem readonly onReport={handleReport} companyPositions={employeeInfoData} />
						</div>
					</div>
					<div className='row'>
						<div className='col mt-5'>
							<button className='btn rounded-pill btn-salvar px-5' data-salid={salaryInfo?.id} onClick={() => setShowModalEdit(true)}>
								Editar
							</button>
						</div>
					</div>

					<div className='row mt-5'>
						<div className='col'>
							<div className='row'>
								{calculation.salaryAnnual && (
									<div className='col-6'>
										<strong className='col-auto p-2'>Salario Anual</strong>
										<p className='col-auto px-2'>{calculation.salaryAnnual}</p>
									</div>
								)}
								{calculation.contrat && (
									<div className='col-6'>
										<strong className='col-4 p-2'>Tipo de Contrato</strong>
										<p className='col-4 px-2'>
											{contractList
												?.filter(contractFilt => employeeProfile?.contract === contractFilt.id)
												.map(contract => {
													return contract.type
												})}
										</p>
									</div>
								)}
								{employeeInfoData[0]?.updated_at && (
									<div className='col-6'>
										<strong className='col-auto p-2'>
											{language.locale == 'ES' ? 'Fecha del último ajuste de salario' : 'Data do último ajuste Salarial'}
										</strong>
										<p className='col-auto px-2'>{formatedDate(employeeInfoData[0]?.updated_at)}</p>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
		</>
	)
}

export default Salario
 */

import { useCallback, useEffect, useState } from 'react'
import { HiCloud, HiCloudArrowDown, HiOutlineInformationCircle } from 'react-icons/hi2'
import { useParams } from 'react-router-dom'

import Swal from 'sweetalert2'

import { Band } from '../../Components/SalaryBand/Band'
import { calcComparative } from '../../Components/SalaryBand/Utils/Calc'
import Masks from '../../Utils/masks'

import SalaryBand from '../../API/Services/Salary/SalaryBand'
import Loading from '../../Components/Loading/Loading'

import { FlagArgentina, FlagBrasil, FlagChile, FlagColombia, FlagEcuador, FlagMexico, FlagPeru, FlagUruguay } from '../../Icons/Flags'

import { salariesAndBenefitsTranslate } from '../../i18n/translatedMessages'

const flags = {
	Argentina: <FlagArgentina width='28px' height='28px' />,
	Brasil: <FlagBrasil width='28px' height='28px' />,
	Chile: <FlagChile width='28px' height='28px' />,
	Colombia: <FlagColombia width='28px' height='28px' />,
	Ecuador: <FlagEcuador width='28px' height='28px' />,
	Mexico: <FlagMexico width='28px' height='28px' />,
	Perú: <FlagPeru width='28px' height='28px' />,
	Uruguay: <FlagUruguay width='28px' height='28px' />,
}

const loggedEmail = localStorage.getItem('email')
const isMayekawa = !!loggedEmail?.includes('@mayekawa')

export default function Salario() {
	const { id: employeeId } = useParams()
	const [data, setData] = useState(null)
	const [loadingReport, setLoadingReport] = useState(null)

	const loadData = useCallback(async () => {
		try {
			const { id } = JSON.parse(localStorage.getItem('user'))
			const response = await SalaryBand.getEmployees(id)

			setData(response)
		} catch (error) {
			Swal.fire({
				title: 'Error',
				text: 'Estamos experimentando problemas, por favor recarga la página.',
				icon: 'info',
			})
		}
	}, [])

	useEffect(() => {
		loadData()
	}, [loadData])

	if (isMayekawa) {
		Swal.fire({
			title: 'Acción no permitida.',
			text: 'No tienes acceso a esta pagina',
			icon: 'warning',
		})
		return
	}

	const donwloadReport = async id => {
		let bringReport = null
		try {
			setLoadingReport(id)
			const getData = await SalaryBand.getReportDataEmployee(id)
			if (getData) {
				bringReport = await SalaryBand.getReportEmployee(getData)
			}
		} catch (error) {
		} finally {
			setLoadingReport(null)
			if (bringReport) {
				return window.open(
					`https://smtm.co/v1/reports/api_recover?authorization=19c073e1768a3cbf6e9d76390e640f3b&email=${bringReport.report_sent.report_info.params.email}&code=${bringReport.report_sent.report_info.params.code}`,
					'_blank',
					'noopener,noreferrer'
				)
			}
		}
	}

	if (!data) return <Loading />
	return data.employees
		.filter(item => {
			return Number(item.employee_id) === Number(employeeId)
		})
		.map(item => (
			<div className='tw-w-full tw-space-y-2 tw-rounded-md tw-overflow-hidden border'>
				<div className='tw-flex tw-w-full tw-bg-gray-100 tw-px-4 tw-py-2'>
					<div className='tw-font-bold tw-w-3/12 tw-flex tw-justify-start'>{salariesAndBenefitsTranslate.salaryRoleEmployee}</div>
					<div className='tw-font-bold tw-w-1/12 tw-flex tw-justify-center'>{salariesAndBenefitsTranslate.salaryRoleCoin}</div>
					<div className='tw-font-bold tw-w-2/12 tw-flex tw-justify-center'>{salariesAndBenefitsTranslate.salaryRoleSalary}</div>
					<div className='tw-font-bold tw-w-1/12 tw-flex tw-justify-center'>Mercado</div>
					<div className='tw-font-bold tw-w-2/12 tw-flex tw-justify-center'>Comparativo</div>
					<div className='tw-font-bold tw-w-1/12 tw-flex tw-justify-center'>Info</div>
					<div className='tw-font-bold tw-w-1/12 tw-flex tw-justify-center'>Reporte</div>
					<div className='tw-font-bold tw-w-1/12 tw-flex tw-justify-center'></div>
				</div>
				<div className='tw-overflow-y-auto p-2'>
					<div key={item.employee_id} className='tw-flex tw-w-full tw-h-[100px]'>
						<div className='tw-w-3/12 tw-flex tw-items-center tw-gap-8'>
							<div
								title={item.employee_id}
								className='tw-w-[60px] tw-h-[60px] border tw-rounded-full tw-flex tw-items-center tw-justify-center tw-relative tw-text-purple-400 tw-text-4xl'
							>
								<span>{item.name?.charAt(0)}</span>
								{
									<div
										title={item.country.label}
										className='tw-absolute tw-bg-purple tw-w-[27px] tw-h-[27px] tw-bottom-[-10px] tw-right-[-10px] tw-rounded-full tw-flex tw-items-center tw-justify-center'
									>
										{flags[item.country.label]}
									</div>
								}
							</div>
							<div className=''>
								<h4 className='tw-text-base tw-font-bold tw-m-0 tw-p-0'>{item?.name}</h4>
								<span className='tw-text-sm tw-text-gray-600'>{item?.jobname}</span>
							</div>
						</div>
						<div className='tw-w-1/12 tw-flex tw-flex-col tw-items-center tw-justify-center'>
							<h4 className='tw-text-base tw-p-0'>{item.currency}</h4>
							<span>{item.salary_model}</span>
						</div>
						<div className='tw-w-2/12 tw-flex tw-items-center tw-justify-center'>
							{item.monthly_salary === 0 || item.monthly_salary === null ? (
								<span className='tw-bg-gray-200 tw-px-3 tw-rounded-full tw-text-gray-500'>{salariesAndBenefitsTranslate.salaryNotInfomed}</span>
							) : (
								Masks.setDots(item.monthly_salary)
							)}
						</div>
						<div className='tw-w-1/12 tw-flex tw-items-center tw-justify-center'>
							{Masks.setDots(item.market_salary) || (
								<span className='tw-bg-green-500 tw-px-3 tw-rounded-full tw-text-white'>{salariesAndBenefitsTranslate.salaryProcessing}</span>
							)}
						</div>
						<div className='tw-w-2/12 tw-flex tw-items-center tw-justify-center'>
							{calcComparative(Number(item.market_salary), item.monthly_salary)}
						</div>
						<div className='tw-w-1/12 tw-flex tw-items-center tw-justify-center'>
							<HiOutlineInformationCircle size={28} className='tw-text-purple cursor-pointer hover:tw-text-purple-400 ' />
						</div>
						<div className='tw-w-1/12 tw-flex tw-items-center tw-justify-center'>
							{loadingReport === item.employee_id ? (
								<svg
									className='tw-animate-spin -tw-ml-1 tw-mr-3 tw-h-5 tw-w-5 tw-text-purple'
									xmlns='http://www.w3.org/2000/svg'
									fill='none'
									viewBox='0 0 24 24'
								>
									<circle className='opacity-25' cx='12' cy='12' r='10' stroke='currentColor' strokeWidth='4'></circle>
									<path
										className='opacity-75'
										fill='currentColor'
										d='M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z'
									/>
								</svg>
							) : item.market_salary ? (
								<button
									className='border-0 tw-bg-transparent p-0 m-0'
									onClick={() => {
										donwloadReport(item.employee_id)
									}}
								>
									<HiCloudArrowDown size={28} className='tw-text-purple cursor-pointer hover:tw-text-purple-400 active:tw-text-purple-600' />
								</button>
							) : (
								<HiCloud size={28} className='tw-text-gray-300' />
							)}
						</div>
					</div>

					<Band employee={item} />
				</div>
			</div>
		))
}
